// src/utils/debugExperiments/useExperiment.ts
import { useSyncExternalStore } from "react"
import { debugExperiments } from "./store"
import type { ExperimentKey } from "./experiments"

/**
 * Reactively reads a debug experiment value. Components using this hook
 * re-render whenever the toggle changes in DevToolsButton.
 *
 * Returns `false` if the store has not been initialized (i.e. for non-debug
 * users — in that case `debugExperiments.init()` is never called, but
 * `get()` still returns the in-memory default of `false`).
 */
export const useExperiment = (key: ExperimentKey): boolean => {
  return useSyncExternalStore(
    (cb) => debugExperiments.subscribe(cb),
    () => debugExperiments.get(key),
    () => false
  )
}
